import React from 'react';
import { VideoSection } from '../components/VideoSection';
import { Button } from '../components/Button';
import { Footer } from '../components/Footer';
import { PaymentIcons } from '../components/PaymentIcons';
import { SecurityBadges } from '../components/SecurityBadges';
import { Header } from '../components/Header';
export function TwoBricksPage() {
  return <div className="w-full min-h-full bg-white" data-id="element-115">
      <Header data-id="element-116" />
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8" data-id="element-117">
        <div className="text-center mb-8" data-id="element-118">
          <span className="bg-yellow-100 text-red-600 px-4 py-2 rounded-full font-bold inline-block mb-4 animate-[slideIn_0.5s_ease-out]" data-id="element-119">
            Limited Time Offer: Buy 1 Get 1 at $99 ($70 off!)
          </span>
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-120">
            Double Your Practice Power with Two Blue Bricks
          </h2>
        </div>
        <VideoSection data-id="element-121" />
        <div className="prose prose-lg max-w-none" data-id="element-122">
          <div className="mb-10" data-id="element-123">
            <h3 className="text-2xl font-semibold text-gray-800" data-id="element-124">
              Why Golfers Are Getting Two Blue Bricks
            </h3>
            <ul className="mt-4 space-y-4 text-gray-700" data-id="element-125">
              <li className="flex items-start" data-id="element-126">
                <span className="text-green-600 font-bold mr-2" data-id="element-127">✓</span>
                <span data-id="element-128">
                  <strong data-id="element-129">Practice at Home AND the Range</strong> - Keep one in
                  your practice space at home and one in your golf bag
                </span>
              </li>
              <li className="flex items-start" data-id="element-130">
                <span className="text-green-600 font-bold mr-2" data-id="element-131">✓</span>
                <span data-id="element-132">
                  <strong data-id="element-133">Perfect Gift for Golf Buddies</strong> - Share the
                  secret to better golf with your playing partners
                </span>
              </li>
              <li className="flex items-start" data-id="element-134">
                <span className="text-green-600 font-bold mr-2" data-id="element-135">✓</span>
                <span data-id="element-136">
                  <strong data-id="element-137">Save $70 + Free U.S. Shipping</strong> - Get your
                  second Blue Brick for just $99 (regular price: $169)
                </span>
              </li>
            </ul>
          </div>
          <div className="bg-blue-50 p-6 rounded-xl mb-10" data-id="element-138">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4" data-id="element-139">
              Limited Time 2-for-1 Special Offer
            </h3>
            <div className="space-y-4" data-id="element-140">
              <p className="text-gray-700" data-id="element-141">
                <strong data-id="element-142">
                  Get TWO Blue Bricks for less than the regular price of one!
                </strong>
              </p>
              <div className="flex justify-between items-center border-b border-blue-200 pb-4" data-id="element-143">
                <span data-id="element-144">First Blue Brick</span>
                <span className="font-semibold" data-id="element-145">$129</span>
              </div>
              <div className="flex justify-between items-center border-b border-blue-200 pb-4" data-id="element-146">
                <span data-id="element-147">Second Blue Brick</span>
                <span className="font-semibold text-green-600" data-id="element-148">Only $99</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-149">
                <span className="font-bold" data-id="element-150">Your Total Savings</span>
                <span className="font-bold text-green-600" data-id="element-151">$70</span>
              </div>
            </div>
          </div>
          <div className="space-y-6 mb-10" data-id="element-152">
            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-153">
              <p className="italic text-gray-700" data-id="element-154">
                "I bought two - one for home practice and one for the range.
                Best decision ever. My whole group has improved their ball
                striking!"
              </p>
              <p className="text-gray-600 font-medium" data-id="element-155">– Mike R.</p>
            </div>
          </div>
        </div>
        <div className="flex justify-center mt-12 mb-8" data-id="element-156">
          <div className="w-72" data-id="element-157">
            <Button href="https://secure.shotcraftgolf.com/b29-checkout-2-for-1/" data-id="element-158">
              Get 2 Blue Bricks Now
            </Button>
          </div>
        </div>
        <div className="mt-4 mb-2" data-id="element-159">
          <PaymentIcons data-id="element-160" />
        </div>
        <div className="mb-8" data-id="element-161">
          <SecurityBadges data-id="element-162" />
        </div>
        <div className="mb-8 flex justify-center" data-id="element-163">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bEvbrxAiDwc8USGWLWmKxg/guarantee-1.png" alt="60 Day Money Back Guarantee Badge" className="w-32" data-id="element-164" />
        </div>
      </div>
      <Footer data-id="element-165" />
    </div>;
}